import Super from './-resources';

export default class SiteBillingReceipts extends Super {
  thisType = 'receipt';
}
